import * as constants from '../constants';

const initialState = {
    data: [],
    item: {}
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getPesticideHazardClass.success: {
            return {
                ...state, data: action.payload.results
            };
        }

        case constants.getPesticideHazardClassItem.success: {
            return {
                ...state, item: { ...action.payload }
            };
        }

        default:
            return state;
    }
}
